// db/scalars.ts
import { registerScalar } from "@adornis/baseql/metadata/register.js";
import { GraphQLString } from "graphql";
var HTML = class {
  constructor() {
    this.isHTML = true;
  }
  static {
    this._class = "HTML";
  }
};
var Markdown = class {
  constructor() {
    this.isMarkdown = true;
  }
  static {
    this._class = "Markdown";
  }
};
var SFile = class {
  constructor() {
    this.isFile = true;
  }
  static {
    this._class = "SFILE";
  }
};
registerScalar({
  name: "SFile",
  customScalarConfig: {
    description: "The `SFile` scalar type represents textual data, represented as UTF-8 character sequences. The String type is most often used by GraphQL to represent free-form human-readable text.",
    serialize: GraphQLString.serialize,
    parseValue: GraphQLString.parseValue,
    parseLiteral: GraphQLString.parseLiteral
  },
  coerceValue: (value) => String(value),
  type: SFile
});
registerScalar({
  name: "HTML",
  customScalarConfig: {
    description: "The `HTML` scalar type represents textual data, represented as UTF-8 character sequences. The String type is most often used by GraphQL to represent free-form human-readable text.",
    serialize: GraphQLString.serialize,
    parseValue: GraphQLString.parseValue,
    parseLiteral: GraphQLString.parseLiteral
  },
  coerceValue: (value) => String(value),
  type: HTML
});
registerScalar({
  name: "Markdown",
  customScalarConfig: {
    description: "The `Markdown` scalar type represents textual data like String but signals to consuming code that it contains markdown.",
    serialize: GraphQLString.serialize,
    parseValue: GraphQLString.parseValue,
    parseLiteral: GraphQLString.parseLiteral
  },
  coerceValue: (value) => String(value),
  type: Markdown
});
export {
  HTML,
  Markdown,
  SFile
};
